// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__lQg21","title":"BackImages_title__CvZK4","images":"BackImages_images__2BhKa"};